import '../assets/js/index.js';

export const environment = {
  production: false,
  staging: true,
  development: false,
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts